import { Button } from "@/components/ui/button";
import { PackageCheck } from "lucide-react";
import { ConferenciaSearchBar } from "./ConferenciaSearchBar";

// Banner violeta: N entregas aguardando conferência → aceite por scanner/nº do pedido ou "Confirmar Todas".
export function ConfirmarTodasBanner({ count, onLookup, onOpenScanner, onConfirmarTodas, disabled }) {
  return (
    <div className="rounded-2xl border-2 border-violet-500 bg-violet-50 p-4 shadow-md" data-testid="confirmar-todas-banner">
      <div className="flex items-start gap-3">
        <PackageCheck className="w-8 h-8 text-violet-700 shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-extrabold text-violet-900 uppercase tracking-wide">{count} entrega(s) aguardando conferência</div>
          <div className="text-xs text-violet-800 mt-0.5">Escaneie o código de barras ou digite o nº do pedido pra dar aceite.</div>
        </div>
      </div>
      <div className="mt-3">
        <ConferenciaSearchBar onSubmit={onLookup} onOpenScanner={onOpenScanner} disabled={disabled} />
      </div>
      <Button size="lg" className="w-full mt-3 h-12 bg-violet-700 hover:bg-violet-800 text-white font-extrabold text-base"
        onClick={onConfirmarTodas} disabled={disabled} data-testid="btn-confirmar-todas">
        <PackageCheck className="w-5 h-5 mr-2" />
        Confirmar Todas ({count})
      </Button>
    </div>
  );
}
